import { inject, injectable } from "inversify";
import { PlayerState } from "../api/model/playerState/PlayerState";
import { I18n } from "../i18n/i18n";
import { FullPlayerConfiguration } from "../model/playerConfiguration/FullPlayerConfiguration";
import { IframeNotifierPlayerActionState } from "../model/playerState/IframeNotifierPlayerActionState";
import { IframeNotifierPlayerState } from "../model/playerState/IframeNotifierPlayerState";
import { IframeNotifierVintomError } from "../model/playerState/IframeNotifierVintomError";
import { ConfigurationBuilder } from "./configurationBuilder/ConfigurationBuilder";
import { TYPES } from "./di/types";
import { AnalyticsCollector } from "./playerAnalytics/AnalyticsCollector";
import { PlayerManager } from "./PlayerManager";

@injectable()
export class NotSupportedBrowserPlayerManagerImpl implements PlayerManager {

  private i18n: I18n;

  private playerConfig: FullPlayerConfiguration;

  private videoCode: string;
  private configurationJSON;
  private configurationOverrideJSON;
  private personalizationJSON;

  private configurationLoaded: boolean;
  private queueLogNotSupportedBrowser: boolean;

  constructor(
      @inject(TYPES.analyticsCollector.AnalyticsCollector) private analyticsCollector: AnalyticsCollector,
      @inject(TYPES.configurationBuilder.ConfigurationBuilder) private configurationBuilder: ConfigurationBuilder) {
  }

  run(i18n: I18n, videoCode: string, configurationJSON: any, configurationOverrideJSON: any, personalizationJSON: any) {
    this.videoCode = videoCode;
    this.configurationJSON = configurationJSON;
    this.configurationOverrideJSON = configurationOverrideJSON;
    this.personalizationJSON = personalizationJSON;
    this.i18n = i18n;

    this.configurationBuilder.build(videoCode, configurationJSON, configurationOverrideJSON, personalizationJSON)
        .then((configuration) => this.playerConfig = configuration)
        .then(() => this.analyticsCollector.initialize(
            this.playerConfig.code,
            this.playerConfig.videoDate,
            this.playerConfig.analyticsEndpoints,
            this.playerConfig.campaign,
            this.playerConfig.groupId))
        .then(() => {
          this.configurationLoaded = true;
          if (this.queueLogNotSupportedBrowser) {
            this.logNotSupportedBrowser();
            this.queueLogNotSupportedBrowser = false;
          }
        });
  }

  logNotSupportedBrowser(): void {
    if (this.configurationLoaded) {
      this.analyticsCollector.logNotSupportedBrowser();
    } else {
      this.queueLogNotSupportedBrowser = true;
    }
  }

  play(): void {
  }

  pause(): void {
  }

  replay(): void {
  }
  
  performAction(ctaId: number, actionId: number, ...args: any[]): void {
  }

  moveToScenarioElement(id: number): void {
  }

  prepareForRemove(): void {
  }

  registerOnReady(callback: () => void): void {
  }

  registerOnError(callback: (error: IframeNotifierVintomError) => void): void {
  }

  registerOnPlay(callback: (payload: IframeNotifierPlayerState) => void): void {
  }

  registerOnPause(callback: (payload: IframeNotifierPlayerState) => void): void {
  }

  registerOnFinish(callback: (payload: IframeNotifierPlayerState) => void): void {
  }

  registerOnAction(callback: (payload: IframeNotifierPlayerActionState) => void): void {
  }

  getState(): PlayerState {
    return undefined;
  }
}
